/** *@name:index *@author:dingyongya *@date:2022/10/8 17:00 *@update:2022/10/8 17:00 */
<template>
  <el-popover
    ref="popover"
    placement="bottom-start"
    v-model="visible"
    popper-class="custom_year_range"
    trigger="manual"
    v-clickoutside="handleClose"
  >
    <div class="_inner floatPanel">
      <div class="_inner leftPanel">
        <div class="_inner panelHead">
          <i class="_inner el-icon-d-arrow-left" @click="onClickLeft"></i>
          <span>
            {{ leftYearList[0] + $MGUI.i18n.t('年') + ' - ' + leftYearList[11] + $MGUI.i18n.t('年') }}
          </span>
        </div>
        <div class="_inner panelContent">
          <div
            :class="{
              oneSelected: item === startYear && oneSelected,
              startSelected: item === startYear,
              endSelected: item === endYear,
              betweenSelected: item > startYear && item < endYear,
            }"
            v-for="item in leftYearList"
            :key="item"
          >
            <a
              :class="{
                cell: true,
                _inner: true,
                selected: item === startYear || item === endYear,
              }"
              @click="() => onClickItem(item)"
              @mouseover="() => onHoverItem(item)"
            >
              {{ item }}
            </a>
          </div>
        </div>
      </div>
      <div class="_inner rightPanel">
        <div class="_inner panelHead">
          <i class="_inner el-icon-d-arrow-right" @click="onClickRight"></i>
          <span>{{ rightYearList[0] + $MGUI.i18n.t('年') + ' - ' + rightYearList[11] + $MGUI.i18n.t('年') }}</span>
        </div>
        <div class="_inner panelContent">
          <div
            :class="{
              oneSelected: item === startYear && oneSelected,
              startSelected: item === startYear,
              endSelected: item === endYear,
              betweenSelected: item > startYear && item < endYear,
            }"
            v-for="item in rightYearList"
            :key="item"
          >
            <a
              :class="{
                cell: true,
                _inner: true,
                selected: item === endYear || item === startYear,
              }"
              @click="() => onClickItem(item)"
              @mouseover="() => onHoverItem(item)"
            >
              {{ item }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div slot="reference">
      <div
        class="el-date-editor el-range-editor el-input__inner"
        :class="[
          'el-date-editor--monthrange',
          pickerSize ? `el-range-editor--${pickerSize}` : '',
          pickerDisabled ? 'is-disabled' : '',
          pickerVisible ? 'is-active' : '',
        ]"
        ref="reference"
        @mouseenter="handleMouseEnter"
        @mouseleave="() => (showClose = false)"
        @keydown="handleKeydown"
      >
        <i :class="['el-input__icon', 'el-range__icon', 'el-icon-date']"></i>
        <input
          data-class="mousetrap"
          autocomplete="off"
          ref="inputLeft"
          type="text"
          name="yearInput"
          :placeholder="$MGUI.i18n.t(startPlaceholder)"
          :value="startShowYear"
          @focus="onFocus"
          @keyup="() => handleInput('start')"
          @keydown="handleKeydown"
          class="el-range-input"
        />
        <slot name="range-separator">
          <span class="el-range-separator">{{ $MGUI.i18n.t(rangeSeparator) }}</span>
        </slot>
        <input
          data-class="mousetrap"
          autocomplete="off"
          ref="inputRight"
          type="text"
          name="yearInput"
          :placeholder="$MGUI.i18n.t(endPlaceholder)"
          :value="endShowYear"
          @focus="onFocus"
          @keyup="() => handleInput('end')"
          class="el-range-input"
        />
        <i
          @click="handleClickIcon"
          :class="[showClose ? '' + 'el-icon-circle-close' : '']"
          class="el-input__icon el-range__close-icon"
        ></i>
      </div>
    </div>
  </el-popover>
</template>

<script>
  import { clickoutside, SELECT_STATE } from '../utils'
  export default {
    name: 'MgYearRange',
    directives: { clickoutside },
    computed: {
      oneSelected() {
        return this.curState === SELECT_STATE.selecting && (this.startYear === this.endYear || this.endYear == null)
      },
      leftYearList() {
        return this.yearList.slice(0, 12)
      },
      rightYearList() {
        return this.yearList.slice(12, 24)
      },
      reference() {
        const reference = this.$refs.reference
        return reference.$el || reference
      },

      refInput() {
        if (this.reference) {
          return [].slice.call(this.reference.querySelectorAll('input'))
        }
        return []
      },
    },
    props: {
      startPlaceholder: {
        default: '开始年',
      },
      endPlaceholder: {
        default: '结束年',
      },
      rangeSeparator: {
        default: '至',
      },
      value: {
        default: null,
      },
      pickerSize: {
        default: 'small',
      },
      pickerDisabled: {
        default: false,
      },
    },
    data() {
      return {
        showClose: false,
        pickerVisible: false,
        itemBg: {},
        startShowYear: null,
        endShowYear: null,
        yearList: [],
        visible: false,
        startYear: null,
        endYear: null,
        curYear: 0,
        curSelectedYear: 0,
        curState: SELECT_STATE.unselect,
      }
    },
    methods: {
      handleClickIcon() {
        this.startShowYear = null
        this.endShowYear = null
        this.visible = false
        this.showClose = false
      },

      handleMouseEnter() {
        if (this.pickerDisabled) return
        if (this.endShowYear) {
          this.showClose = true
        }
      },

      blur() {
        this.refInput.forEach((input) => input.blur())
      },

      handleKeydown() {
        this.blur()
      },

      handleClose() {
        this.visible = false
      },

      handleInput(type) {
        switch (type) {
          case 'start':
            if (isNaN(this.startShowYear)) {
              this.startShowYear = this.startYear
              return
            }
            this.startYear = this.startShowYear * 1
            break
          case 'end':
            if (isNaN(this.endShowYear)) {
              this.endShowYear = this.endYear
              return
            }
            this.endYear = this.endShowYear * 1
            break
        }
        ;[this.startYear, this.endYear] = [this.endYear, this.startYear]
        this.startShowYear = this.startYear
        this.endShowYear = this.endYear
      },

      onHoverItem(iYear) {
        if (this.curState === SELECT_STATE.selecting) {
          const tmpStart = this.curSelectedYear
          this.endYear = Math.max(tmpStart, iYear)
          this.startYear = Math.min(tmpStart, iYear)
        }
      },

      async onClickItem(selectYear) {
        if (this.curState === SELECT_STATE.unselect || this.curState === SELECT_STATE.selected) {
          this.startYear = selectYear
          this.curSelectedYear = selectYear
          this.endYear = null
          this.curState = SELECT_STATE.selecting
        } else if (this.curState === SELECT_STATE.selecting) {
          this.endShowYear = this.endYear || this.startYear
          this.endYear = selectYear
          this.startShowYear = this.startYear
          this.curState = SELECT_STATE.selected
          await this.$nextTick()
          this.visible = false
          this.pickerVisible = false
          this.$parent?.$parent?.$parent?.$parent?.$parent.clearValidate?.()
        }
      },

      async onFocus() {
        this.pickerVisible = true
        this.visible = true
        if (!this.startShowYear && !this.endShowYear) {
          this.endYear = null
          this.startYear = null
        }
      },

      updateYearList() {
        const startYear = ~~(this.curYear / 10) * 10
        this.yearList = []
        for (let index = 0; index < 24; index++) {
          this.yearList.push(startYear + index)
        }
      },

      onClickLeft() {
        this.curYear = this.curYear * 1 - 12
        this.updateYearList()
      },

      onClickRight() {
        this.curYear = this.curYear * 1 + 12
        this.updateYearList()
      },
    },
    watch: {
      value: {
        handler(val) {
          if (val?.length === 0) {
            this.startShowYear = null
            this.endShowYear = null
          } else {
            const [first, end] = val || []
            this.startShowYear = first
            this.endShowYear = end
          }
        },
        immediate: true,
        deep: true,
      },

      startShowYear: {
        handler(val) {
          this.$emit('input', val ? [val, this.endShowYear || ''] : [])
        },
        immediate: true,
        deep: true,
      },

      endShowYear: {
        handler(val) {
          this.$emit('input', val ? [this.startShowYear || '', val] : [])
        },
        immediate: true,
        deep: true,
      },
    },
    created() {
      const [startYear, endYear] = this.value || []
      if (startYear) {
        this.startYear = Number(startYear)
        this.endYear = Number(endYear)
        this.curState = SELECT_STATE.selected
        this.curYear = startYear
      } else {
        this.curYear = this.dayjs().format('YYYY')
      }
      this.updateYearList()
    },
  }
</script>
<style lang="scss" scoped>
  $--color-primary: #e60012;

  :deep(.el-date-editor--monthrange.el-input__inner) {
    width: 100%;
  }
  a {
    color: #0b1523;
  }
  .custom_year_range {
    .floatPanel {
      > div {
        width: 50%;
      }
      padding: 0 16px;
      display: flex;
      background-color: #fff;
      z-index: 2000;
      border-radius: 4px;
      width: 650px;
      height: 250px;
      top: 40px;
      left: -50px;
      .panelContent {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: calc(100% - 70px);
        .oneSelected {
          border-top-right-radius: 24px;
          border-bottom-right-radius: 24px;
        }
        .startSelected {
          background-color: #f2f6fc;
          border-top-left-radius: 24px;
          border-bottom-left-radius: 24px;
        }
        .endSelected {
          background-color: #f2f6fc;
          border-top-right-radius: 24px;
          border-bottom-right-radius: 24px;
        }
        .betweenSelected {
          background-color: #f2f6fc;
        }
        > div {
          width: 75px;
          height: 48px;
          line-height: 48px;
          margin: 3px 0;
          // border-radius: 24px;
          text-align: center;
          a {
            display: inline-block;
            width: 60px;
            height: 36px;
            cursor: pointer;
            line-height: 36px;
            border-radius: 18px;
            &:hover {
              color: $--color-primary;
            }
          }
          .selected {
            background-color: $--color-primary;
            color: #fff;
            &:hover {
              color: #fff !important;
            }
          }
        }
      }
      .panelHead {
        position: relative;
        height: 46px;
        line-height: 46px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 16px;
          font-weight: 500;
          padding: 0 5px;
          line-height: 22px;
          text-align: center;
          cursor: pointer;
          color: #606266;
          &:hover {
            color: $--color-primary;
          }
        }
        i {
          position: absolute;
          cursor: pointer;
          &:hover {
            color: $--color-primary;
          }
        }
      }
      .rightPanel {
        padding-left: 8px;
      }
      .leftPanel .panelHead i {
        left: 20px;
      }
      .rightPanel .panelHead i {
        right: 20px;
      }
    }
    .floatPanel::before {
      content: '';
      height: 100%;
      top: 0;
      position: absolute;
      left: 50%;
      width: 1px;
      border-left: 1px solid #e4e4e4;
    }
  }
  .range_input {
    appearance: none;
    border: none;
    outline: 0;
    padding: 0;
    width: 39%;
    color: #606266;
    line-height: 1;
    height: 100%;
    margin: 0;
    text-align: center;
    display: inline-block;
  }
  .yearPicker {
    input:first-child {
      text-align: right;
    }
    .labelText {
      position: absolute;
      left: 8px;
    }
    background-color: #fff;
    span {
      padding: 0 8px;
      height: 32px;
      line-height: 32px;
    }
    border: 1px solid #eff1f3;
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    padding: 0 28px 0 8px;
    box-sizing: border-box;
  }
  input {
    width: 60px;
    border: none;
    height: 32px;
    line-height: 32px;
    box-sizing: border-box;
    background-color: transparent;
  }
  input:focus {
    outline: none;
    background-color: transparent;
  }
  .yearPicker:hover {
    border-color: $--color-primary;
  }
  .dateIcon {
    position: absolute;
    right: 16px;
    top: 9px;
    color: #adb2bc;
  }
</style>
